import script from "./WeChatMsgWindow.vue?vue&type=script&lang=ts&setup=true"
export * from "./WeChatMsgWindow.vue?vue&type=script&lang=ts&setup=true"

import "./WeChatMsgWindow.vue?vue&type=style&index=0&id=48a196d0&lang=css"

const __exports__ = script;

export default __exports__